import type { InteractionMode } from '../../interactions-overlay/types.js';
import { SelectionAreaVariant } from '../../selection-area/types.js';
import type { InteractionState } from '../types.js';

export function reduceInteractionMode<T extends InteractionState>(
  interactionMode: InteractionMode,
) {
  return (prev: T): T => ({ ...prev, interactionMode });
}

export function reduceSelectionAreaVariant<T extends InteractionState>(
  variant: SelectionAreaVariant,
) {
  return (prev: T): T => ({ ...prev, select: { ...prev.select, variant } });
}
